import BossModel from "@/models/BossModel";
import File from "@/models/File/File";
import Message from "@/models/Agent/Message/Message";

export default class Attachment extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'agent/message/attachment';

    /**
     *
     * @type {string}
     */
    static entity = 'agentMessageAttachment';

    static fields() {
        return {
            id: this.number(null).nullable(),
            file_id: this.number(null),
            agent_message_id: this.number(null),
            created_at: this.attr(null),
            file: this.belongsTo(File, 'file_id'),
            message: this.belongsTo(Message, 'agent_message_id')
        }
    }
}
